import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

export function useRetrieveWebpageKnowledgeBaseMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await axios.post(`/knowledgeBase/${id}/retrieve`)
      return id
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [knowledgeBaseQuery().queryKey.at(0)] })
    },
  })
}
